import script from "./UploadProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadProgress.vue?vue&type=script&setup=true&lang=ts"

import "./UploadProgress.vue?vue&type=style&index=0&id=7bbcf61e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbcf61e"]])

export default __exports__